import styled from "styled-components";

const ButtonsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: ${props => props.isRTL ? "end" : "start"};
  align-items: center;
  gap: 10px 20px;
  margin-top: 10px;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

export default ButtonsContainer;
